import axios from 'axios'
import {errorHelper, messageHelper} from '../helper.js'
import {
    PROFILE_LIST_URL, 
    PROFILE_ADMIN_DETAIL_URL, 
    ALL_ORGANIZATIONS_URL,
} from '../../../vars'

/**
 * @namespace User
 * @description Список всех заявок (Page: /user)
 */
export default {
    state: {
        currentProfileId: null,
        showUserCard: false,
        UserCallId: null,
        needReloadCloseUser: false,
        userAll: [],
        all_organizations: [],
    },

    mutations: {
        UPDATE_USER_ALL(state, data) {
            state.userAll = data;
        },

        SHOW_USER_CARD(state, data){
            state.currentProfileId = data['profile_id'];
            state.UserCallId = data['call_id'];
            state.showUserCard = true;
            state.needReloadCloseUser = false;
        },

        CLOSE_USER_CARD_MUTATION(state, data){
            state.showUserCard = false;
            if(data['need_reload_parent'])
                state.needReloadCloseUser = state.UserCallId;
        },

        UPDATE_ALL_ORGANIZATIONS(state, data) {
            state.all_organizations = data;
        },
    },

    getters: {
        GETTERS_NEED_RELOAD_CLOSE_USER(state){
            return state.needReloadCloseUser;
        },

        GETTERS_CURRENT_PROFILE_ID(state){
            return state.currentProfileId;
        },
        GETTERS_SHOW_USER_CARD(state){
            return state.showUserCard;
        },
        GETTERS_USER_ALL(state) {
            return state.userAll;
        },

        GETTERS_ALL_ORGANIZATIONS(state){
            return state.all_organizations
        },

    },
    actions: {
        async LOAD_ALL_ORGANIZATIONS(ctx, lang){
            try {
                await axios.get(`${ALL_ORGANIZATIONS_URL}?lang=${lang}`)
                .then((res) => ctx.commit('UPDATE_ALL_ORGANIZATIONS', res.data))
                .catch((e) => {
                    errorHelper(e);
                    messageHelper('', 'error', 6000, e);
                });

            } catch (ex) {
                console.log('ex store---> ', ex);
                messageHelper('', 'error', 6000, ex);
            }    
        },
        
        async GET_USER_ALL(ctx, id) {
            try {
                const res = await axios.get(`${PROFILE_ADMIN_DETAIL_URL}?id=${id}`, {
                headers: {
                    Authorization: `Token ${localStorage.token}`,
                },
                });

                await ctx.commit('UPDATE_USER_ALL', res.data);

                return res.data;
            } catch (e) {
                errorHelper(e);
                messageHelper('', 'error', 6000, e);
                console.log(e, ' GET_INPUT_ALL');
                throw e;
            }
        },

        async UPDATE_PROFILE_DETAIL(ctx, data) {
            try {
                const res = await axios.patch(`${PROFILE_ADMIN_DETAIL_URL}`, data, {
                headers: {
                    Authorization: `Token ${localStorage.token}`
                }
                })
                return res
            } catch (e) {
                errorHelper(e)
                messageHelper('', 'error', 6000, e)
                throw e
            }
        },
        
        CLOSE_USER_CARD(ctx, data){
            ctx.commit('CLOSE_USER_CARD_MUTATION', data);
        },
        /**
         * Получает список BS и записывает
         * @param {Object} ctx
         * @throws {Object} Ошибка запроса данных
         *
         * @memberof Main
         */
        async LOAD_PROFILE_LIST(ctx, data) {
            try {
                const res = await axios.get(`${PROFILE_LIST_URL}?type=${data.type}`, {
                    headers: {
                        Authorization: `Token ${localStorage.token}`,
                    },
                });
                return res.data

            } catch (ex) {
                console.log('ex store---> ', ex);
                messageHelper('', 'error', 6000, ex);
            }    
        },

    }
}